export enum CategoryModuleTypeEnum {
  PublicCourse = 'PublicCourse',
  BaseModule = 1,
  Jncy = 2,
  SafetyTraining = 3,
  AadultEducation = 4,
  CadreEducation = 5,
  ExamAndQuestion = 6,
}

export const CategoryModuleInfoMap = {
  [CategoryModuleTypeEnum.PublicCourse]: {
    title: '公开课',
    desc: '依据《煤炭行业人才培养与队伍建设指导意见》和中国煤炭工业协会培训中心职责，以人社部专业技术人才继续教育、煤炭大讲堂、企业管理论坛等为核心师资、建设覆盖行业发展形势、煤炭第一课、事故案例警示教育等专题资源体系，成为提供行业公共服务的重要阵地。',
    logoFile: 'categoryIndex/publicCourse.png',
    courseTitle: '公开课程',
  },
  [CategoryModuleTypeEnum.SafetyTraining]: {
    title: '安全培训',
    desc: '依据《煤矿安全培训规定》和《安全生产培训机构基本条件》(AQ8011-2023)强制标准，以高级以上职称或注册安全工程师为主要师资，建设覆盖井工及露天煤矿 “三项岗位人员”和非煤特种作业人员的全新安全培训课程体系，成为贵州等地方“三项岗位人员”线上安全生产培训主要平台。',
    logoFile: 'categoryIndex/safetyTraining.png',
    courseTitle: '安全课程',
  },
  [CategoryModuleTypeEnum.AadultEducation]: {
    title: '继续教育',
    desc: '依据《专业技术人员继续教育规定》（人社部25号令）和国家人社部专业技术人员继续教育基地标准，以煤炭工业技术委员会为核心师资，建设覆盖煤炭全产业链和生命周期的专业基础知识和“七新”专题资源体系，成为员工入职与岗位调整继续教育及专业技术人员知识更新培训的主渠道。',
    logoFile: 'categoryIndex/adultEducation.png',
    courseTitle: '公需课堂',
  },
  [CategoryModuleTypeEnum.CadreEducation]: {
    title: '干部教育',
    desc: '依据《干部教育培训工作条例》和《全国干部教育规划》，以中央及省级党校、管理干部学院和政策法规起草者、主笔人为主要师资，建设涵盖政治理论、发展战略、经营管理、产业政策的干部素质能力提升资源体系，成为宣贯赋能的得力助手。',
    logoFile: 'categoryIndex/cadreEducation.png',
    courseTitle: '干部课堂',
  },
};
